const site =
    process.env.NEXT_PUBLIC_STAGE === 'prod'
        ? 'https://web.steps.me'
        : process.env.NEXT_PUBLIC_STAGE === 'dev'
            ? 'https://devweb.steps.me'
            : 'http://localhost:3030';

const config = {
    api: {
        address:
            process.env.NEXT_PUBLIC_STAGE === 'prod'
                ? process.env.REACT_APP_PROD_DOMAIN || 'https://api.steps.me/v1'
                : process.env.REACT_APP_DOMAIN === 'dev'
                    ? process.env.REACT_APP_DOMAIN || 'https://dev.steps.me/dev'
                    : process.env.REACT_APP_DOMAIN || 'https://dev.steps.me/dev',
    },
    version: {
        path:
            process.env.NEXT_PUBLIC_STAGE === 'prod'
                ? process.env.REACT_APP_PROD_VERSION || '3.12.2.0P'
                : process.env.NEXT_PUBLIC_STAGE === 'dev'
                    ? process.env.REACT_APP_TEST_VERSION || '3.12.2.0D'
                    : process.env.REACT_APP_VERSION || '3.12.2.0D',
    },
    domain: {
        address:
        // TODO: This will only work for client side requests, but this is confusing.
        // we should use the same config api and merge this with api.address
            process.env.REACT_APP_ENV === 'prod'
                ? process.env.REACT_APP_PROD_DOMAIN || 'https://api.steps.me/v1'
                : process.env.REACT_APP_DOMAIN === 'test'
                    ? process.env.REACT_APP_DOMAIN || 'https://dev.steps.me/dev'
                    : process.env.REACT_APP_DOMAIN || 'https://dev.steps.me/dev',
        url:
            process.env.REACT_APP_ENV === 'prod'
                ? process.env.REACT_APP_PROD_URL || 'https://mapmanager.steps.me'
                : process.env.REACT_APP_ENV === 'test'
                    ? process.env.REACT_APP_TEST_URL || 'https://devdashboard.steps.me'
                    : process.env.REACT_APP_URL || 'https://devdashboard.steps.me',
    },
    mixpanel: {
        token:
            process.env.NEXT_PUBLIC_STAGE === 'prod'
                ? process.env.MIXPANEL_TOKEN || '077ff37ea1f556ace8f37a5754faca1c'
                : process.env.NEXT_PUBLIC_STAGE === 'dev'
                    ? process.env.MIXPANEL_TOKEN || '72123733c2cb16af4962b13a8c0c1243'
                    : process.env.MIXPANEL_TOKEN || '72123733c2cb16af4962b13a8c0c1243',
    },
    branch: {
        key:
            process.env.NEXT_PUBLIC_STAGE === 'prod'
                ? process.env.BRANCH_KEY || 'key_live_lnS6lLZQ42dahHSK3DNv4gjpAubqgRM4'
                : process.env.NEXT_PUBLIC_STAGE === 'dev'
                    ? process.env.BRANCH_KEY || 'key_test_mgM9pR4R59bbjJIOYzK6AlbaqxmFmHXb'
                    : process.env.BRANCH_KEY || 'key_test_mgM9pR4R59bbjJIOYzK6AlbaqxmFmHXb',
        props: {
            //DONT USE MIXPANELID WHILE THE LINK SHOULD TO BE SHARED! IMPORTANT!
            openMapInApp: (mapId, { feature, stage, mixpanelId } = {}) => ({
                feature: feature || '',
                stage: stage || '',
                data: {
                    $deeplink_path: `open/m/${mapId}`,
                    $android_deeplink_path: `open/m/${mapId}`,
                    $ios_deeplink_path: `open/m/${mapId}`,
                    $desktop_url: `${site}/m/${mapId}`,
                    $canonical_url: `${site}/m/${mapId}`,
                    $og_redirect: `${site}/m/${mapId}`,
                    ...(mixpanelId && mixpanelId.length > 11 ? { link_mixpanel_id: mixpanelId } : {}),
                },
            }),
            openStepInApp: stepId => ({
                data: {
                    $deeplink_path: `open/s/${stepId}`,
                    $android_deeplink_path: `open/s/${stepId}`,
                    $ios_deeplink_path: `open/s/${stepId}`,
                    $desktop_url: `${site}/s/${stepId}`,
                    $canonical_url: `${site}/s/${stepId}`,
                    $og_redirect: `${site}/s/${stepId}`,
                    $ios_url: `${site}/s/${stepId}`,
                    $android_url: `${site}/s/${stepId}`,
                },
            }),
        },
    },
    map_token: process.env.NEXT_PUBLIC_STAGE !== 'prod' && 'dev_secret',
    sitemap_secret_key: process.env.REACT_APP_SITEMAP_SECRET_KEY || 'XWqWRtUcHIi-LjgvoP2DUWW17AsAMFEcgw66fdvF7lkufVpK5UHWl5W9bSRZCIRJRnU5ObTC1qXBrMLCEcKJIA',
    site: site,
    top_ten_domain:
        process.env.NEXT_PUBLIC_STAGE === 'prod'
            ? 'https://www.atly.com'
            : process.env.NEXT_PUBLIC_STAGE === 'dev'
                ? 'https://devweb.atly.com'
                : 'http://localhost:3030',
};

export default config;
